<script>
  import ItemEmail from './EmailItem.vue'
  import ContatoService from '../../../../domain/contato/service/contato'
  import {debounce} from 'lodash'

  const _filtros = {
    busca: '',
    lido: '',
    respondido: '',
    excluido: ''
  }

  export default{
    name: 'lista-emails',
    data () {
      return {
        mensagens: [],
        filtros: Object.assign({}, _filtros),
        pagination: {
          totalPages: 0,
          totalItems: 0,
          atualPage: 1,
          limit: 25
        },
        isLoading: false,
        selected: null
      }
    },
    computed: {
      lidos () {
        return this.lista.filter(item => {
          return item.lido === true && item.isExcluido === false
        })
      },
      naolidos () {
        return this.lista.filter(item => {
          return item.lido === false && item.isExcluido === false
        })
      },
      respondidos () {
        return this.lista.filter(item => {
          return item.isRespondido === true && item.isExcluido === false
        })
      },
      naorespondidos () {
        return this.lista.filter(item => {
          return item.isRespondido === false && item.isExcluido === false
        })
      },
      excluidos () {
        return this.lista.filter(item => {
          return item.isExcluido === true
        })
      },
      todos () {
        return this.lista.filter(item => {
          return item.isExcluido === false
        })
      },
      filtro () {
        return this.$route.query.filter
      },
      busca () {
        return this.$route.query.busca
      },
      tipo () {
        return this.$route.query.tipo
      },
      hasPreviousPage () {
        return this.pagination.atualPage > 1
      },
      hasNextPage () {
        return this.pagination.atualPage < this.pagination.totalPages
      }
    },
    watch: {
      selected: function (a) {
        this.listatmp = a === 'lidos' ? this.lidos : a === 'naolidos' ? this.naolidos : this.todos
      },
      $route: function () {
        this.resetFiltros()
        this.refresh()
      }
    },
    mounted () {
      this.load()
    },
    destroyed () {
    },
    methods: {
      resetFiltros () {
        this.filtros = Object.assign({}, _filtros)
      },
      load: debounce(function () {
        this.getEmails(this.pagination.limit, this.pagination.atualPage, this.montaFiltros())
      }, 500),
      getEmails (limit, page, filtros) {
        this.isLoading = true
        ContatoService.getEmails(limit, page, filtros)
          .then(({data}) => {
            this.mensagens = data.mensagens
            this.pagination.atualPage = data.offset
            this.pagination.totalPages = data.totalPages
            this.$parent.$emit('history', data)
            this.isLoading = false
          })
          .catch(error => {
            this.isLoading = false
            console.log(error.response.data.errors)
          })
      },
      refresh () {
        this.isLoading = true
        this.selected = null
        this.pagination.atualPage = 1
        this.load()
      },
      montaFiltros () {
        let f = this.filtro
        if (f === 'lixeira') {
          this.filtros.excluido = 1
        } else if (f === 'naorespondidos') {
          this.filtros.respondido = 0
        } else if (f === 'respondidos') {
          this.filtros.respondido = 1
        }
        this.filtros.busca = this.busca || ''
        let filtros = this.filtros
        let mount = ''
        // Busca
        if (filtros.busca.length > 0) {
          mount += '&busca=' + filtros.busca
        }
        if (String(filtros.lido).length > 0) {
          mount += '&lido=' + filtros.lido
        }
        if (String(filtros.respondido).length > 0) {
          mount += '&respondido=' + filtros.respondido
        }
        if (String(filtros.excluido).length > 0) {
          mount += '&excluido=' + filtros.excluido
        }
        if (Number(this.tipo) > 0) {
          mount += '&tipo=' + this.tipo
        }
        return mount
      },
      nextPage () {
        this.pagination.atualPage++
        this.load()
      },
      previousPage () {
        this.pagination.atualPage--
        this.load()
      }
    },
    components: { ItemEmail }
  }
</script>

<template>
  <div class="col">
    <div>
      <!-- header -->
      <div class="wrapper bg-light lter b-b">
        <div class="btn-group pull-right">
          <button @click="previousPage()" :disabled="!hasPreviousPage" type="button" class="btn btn-sm btn-bg btn-default"><i class="fa fa-chevron-left"></i></button>
          <button @click="nextPage()" :disabled="!hasNextPage" type="button" class="btn btn-sm btn-bg btn-default"><i class="fa fa-chevron-right"></i></button>
        </div>
        <div class="btn-toolbar">
          <!--div class="btn-group dropdown">
            <button class="btn btn-default btn-sm btn-bg dropdown-toggle" data-toggle="dropdown">
              <span class="dropdown-label">Filter</span>
              <span class="caret"></span>
            </button>
            <ul class="dropdown-menu text-left text-sm">
              <li><a>Unread</a></li>
              <li><a>Starred</a></li>
            </ul>
          </div-->
          <!--<select class="btn-group btn-default btn-bg btn-sm" v-model="selected">
            <option class="btn btn-default btn-sm btn-bg text-left text-sm" disabled selected :value="null">Filtrar por</option>
            <option class="btn btn-default btn-sm btn-bg text-left text-sm" value="lidos">Lidas</option>
            <option class="btn btn-default btn-sm btn-bg text-left text-sm" value="naolidos">Não lidas</option>
            <option class="btn btn-default btn-sm btn-bg text-left text-sm" value="todos">Todos</option>
          </select>
          <div class="btn-group">
            <button class="btn btn-sm btn-bg btn-default" data-toggle="tooltip" data-placement="bottom" data-title="Refresh" data-original-title="" title="" @click="refresh()"><i class="fa fa-refresh"></i></button>
          </div>-->
          <div class="pull-left m-t-xs m-l">
            Página {{pagination.atualPage}} de {{pagination.totalPages}}
          </div>
        </div>
      </div>
      <!-- / header -->
      <div class="msg" v-if="isLoading">Carregando...</div>
      <div class="msg" v-else-if="mensagens.length < 1">Nenhum e-mail a ser mostrado</div>
      <ul class="list-group list-group-lg no-radius m-b-none m-t-n-xxs" v-else>
        <item-email :mail="mail" v-for="mail in mensagens" :key="mail.id"></item-email>
      </ul>
    </div>
  </div>
</template>

<style scoped>
  select:focus {
    background: none;
  }
  .msg {
    margin-left: 40%;
    margin-top: 50px;
  }
</style>



// WEBPACK FOOTER //
// ListaEmails.vue?7c38ea0c